import React from 'react';
import { motion } from 'framer-motion';
import { Urgency } from './Urgency';
export function FinalCTA() {
  const scrollToPricing = () => {
    document.getElementById('pricing')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="py-24 bg-brand-navy text-white px-6 lg:px-8 text-center relative overflow-hidden" data-id="element-79">
      <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-brand-accent/20 rounded-full blur-3xl" data-id="element-80"></div>

      <div className="max-w-3xl mx-auto relative z-10" data-id="element-81">
        <h2 className="text-4xl md:text-5xl font-extrabold mb-6 leading-tight" data-id="element-82">
          Tu próximo cierre puede ser distinto.
        </h2>
        <p className="text-xl text-white/80 mb-10" data-id="element-83">
          Dejá de adivinar qué decir y empezá a usar el sistema que ya le
          funciona a +450 corredores en Argentina.
        </p>

        <button onClick={scrollToPricing} className="bg-brand-accent hover:bg-blue-600 text-white text-xl font-bold py-5 px-12 rounded-xl shadow-soft-lg hover:shadow-xl transition-all transform hover:-translate-y-1 mb-12" data-id="element-84">
          Ver Opciones del Megapack
        </button>
      </div>

      <div className="max-w-4xl mx-auto relative z-10 bg-white rounded-2xl overflow-hidden shadow-2xl" data-id="element-85">
        <Urgency data-id="element-86" />
      </div>
    </section>;
}